import type { TaskStatus } from '@/types/clientTasksApiTypes';

export const CALENDAR_TASK_STATUS = {
  OPEN: 'OPEN',
  COMPLETED: 'COMPLETED',
  CLOSED: 'CLOSED',
} as const satisfies Record<string, TaskStatus>;
